export default () => ({
  invitation: null,
  error: ''
});
